document.addEventListener('DOMContentLoaded', () => {

	const productInfo = document.querySelector('.product-grid__item--content-wrapper.product-grid__sticky')
	if(productInfo) {
		new StickyScroll(productInfo)
	}

})

/**
 * Adjusts the css top property of an element such that it sticks appropriately based on the scroll direction. The
 * container is assumed to be position: sticky, with top: 0 (or whatever).
 *
 * When scrolling down, it'll stick to the bottom of the container, when scrolling up it'll stick to the top of
 * the container.
 */
class StickyScroll {
	constructor(container) {
		if(!container) {
			console.warn('StickyScrollDirection component: No container provided')
			return
		}

		if(window.innerWidth >= 768) {
			this.container = container
			this.currentTop = parseInt(getComputedStyle(this.container).top)
			this.defaultTop = this.currentTop
			this.scrollY = window.scrollY
			this.bindEvents()
		}
	}

	bindEvents() {
		this.scrollListener = this.handleScroll.bind(this)
		window.addEventListener('scroll', this.scrollListener)

		// Use the 'data-cc-sticky-scroll-top' attribute to update the defaultTop. Example use - if the container should
		// stick under the nav, but the nav changes height (either a result from a browser resize, or Theme Editor setting
		// tweak), set this attr the new nav height
		if(typeof this.container.dataset.ccStickyScrollTop !== 'undefined') {
			this.observer = new MutationObserver((mutations) => {
				for(var mutation of mutations) {
					if(mutation.attributeName === 'data-cc-sticky-scroll-top') {
						this.defaultTop = parseInt(mutation.target.dataset.ccStickyScrollTop)
					}
				}
			})
			this.observer.observe(this.container, { attributes: true })
		}
	}

	/**
	 * Updates the current css top based on scroll direction
	 */
	handleScroll() {
		var bounds = this.container.getBoundingClientRect()
		var maxTop = bounds.top + window.scrollY - this.container.offsetTop + this.defaultTop
		var minTop = this.container.clientHeight - window.innerHeight

		if(window.scrollY < this.scrollY) {
			this.currentTop -= window.scrollY - this.scrollY
		}
		else {
			this.currentTop += this.scrollY - window.scrollY
		}

		this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.defaultTop)
		this.scrollY = window.scrollY
		this.container.style.top = `${this.currentTop + 15}px`
	}

	destroy() {
		window.removeEventListener('scroll', this.scrollListener)
		if(this.observer) {
			this.observer.disconnect()
		}
	}
}
